import { render } from "./EPContentPage.vue?vue&type=template&id=59f2e3f0&scoped=true"
import script from "./EPContentPage.vue?vue&type=script&lang=js"
export * from "./EPContentPage.vue?vue&type=script&lang=js"

import "./EPContentPage.vue?vue&type=style&index=0&id=59f2e3f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f2e3f0"]])

export default __exports__